import { desenhaCirc, desenhaQuad } from './Aux.js';

// inicializa variáveis gerais do serviço odv
let zonasLat = [41.169140, 41.164229, 41.135372, 41.212666, 41.268497, 41.243634, 41.207084, 41.281750,
                    41.191969, 41.224141, 41.252249, 41.153451, 41.171661, 41.162514, 41.366196,
                    41.340319, 41.310166, 41.299735, 41.332568, 41.266942, 41.191598, 41.235109, 41.215422,
                    41.126832, 41.113345, 41.080954, 41.092007, 41.128088, 41.046867];
let zonasLong = [-8.549614, -8.507642, -8.560271, -8.633962, -8.635645, -8.602592, -8.567228, -8.563511,
                    -8.672466, -8.696062, -8.717789, -8.624326, -8.664672, -8.574640, -8.757026,
                    -8.560363, -8.610276, -8.534221, -8.726210, -8.697944, -8.498477, -8.532075, -8.464111,
                    -8.611198, -8.581308, -8.601709, -8.655783, -8.655699, -8.635403];

export const doodvRank = (ling, map, rows, lista, l1, l2, l3, l4) => {
    if (!map || !rows || rows.length === 0) {
        if (rows && rows.length === 0) odvAlertaDados(ling);
        return;
    }
    if (l1 > rows.length){
        l1 = rows.length;
    }
    if (l2 > rows.length){
        l2 = rows.length;
    }
    if (l3 > rows.length){
        l3 = rows.length;
    }
    if (l4 > rows.length){
        l4 = rows.length;
    }
    var cor = '#008000';
    let ponto = rows[0];
    let campo = Object.keys(ponto);
    for (let i = 0; i < rows.length; i++) {
        if (i === l1){
            cor = '#00FF00';
        }
        if (i === l2){
            cor = '#FFDF00';
        }
        if (i === l3){
            cor = '#FF8C00';
        }
        if (i === l4){
            cor = '#FF0000';
        }
        let espessura = 4;
        for (let j = 0; j < lista.length; j++) {
            if (rows[i][campo[0]] === lista[j]) { 
                espessura = 1;
                break; }
        }
        if (parseInt(rows[i][campo[0]]) < 83 || 
            (parseInt(rows[i][campo[0]]) > 172 && parseInt(rows[i][campo[0]]) <198)) {
            desenhaCirc(rows[i], cor, espessura, map);
        } else {
            let ref = parseInt(rows[i][campo[0]]) - 198;
            desenhaQuad(zonasLat[ref], zonasLong[ref], cor, espessura, map);
        }
    }
    let desde = " De " + Math.round(rows[l1-1][campo[3]]).toLocaleString('en-US') + " a ";
    let ate = Math.round(rows[0][campo[3]]).toLocaleString('en-US') + " viagens";
    document.getElementById("verdescuro").innerHTML = desde + ate + " (ranking 1 a " + l1 + ")";
    desde = " De " + Math.round(rows[l2-1][campo[3]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l1][campo[3]]).toLocaleString('en-US') + " viagens";
    document.getElementById("verdeclaro").innerHTML = desde + ate + " (ranking " + l1 + " a " + l2 + ")";
    desde = " De " + Math.round(rows[l3-1][campo[3]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l2][campo[3]]).toLocaleString('en-US') + " viagens";
    document.getElementById("amarelo").innerHTML = desde + ate + " (ranking " + l2 + " a " + l3 + ")";
    desde = " De " + Math.round(rows[l4-1][campo[3]]).toLocaleString('en-US') + " a ";
    ate = Math.round(rows[l3][campo[3]]).toLocaleString('en-US') + " viagens";
    document.getElementById("laranja").innerHTML = desde + ate + " (ranking " + l3 + " a " + l4 + ")";
    if (rows.length>82){
        desde = " De " + Math.round(rows[82][campo[3]]).toLocaleString('en-US') + " a ";
    } else {
        desde = " De " + Math.round(rows[rows.length-1][campo[3]]).toLocaleString('en-US') + " a ";
    }
    ate = Math.round(rows[l4][campo[3]]).toLocaleString('en-US') + " viagens";
    document.getElementById("vermelho").innerHTML = desde + ate + " (ranking " + l4 + " a " 
                + rows.length + ")";
}

export const doodvInterv = (ling, map, rows, lista, l1, l2, l3, l4) => {
    if (!map || !rows || rows.length < 1) {
        if (rows && rows.length === 0) odvAlertaDados(ling);
        return;
    }
    let netap;
    let cor = '#008000';
    let ponto = rows[0];
    let campo = Object.keys(ponto);    
    for (let i = 0; i < rows.length; i++) {
        netap = rows[i][campo[3]];
        if (netap<l1){
            cor = '#00FF00';
        }
        if (netap<l2){
            cor = '#FFDF00';
        }
        if (netap<l3){
            cor = '#FF8C00';
        }
        if (netap<l4){
            cor = '#FF0000';
        }
        let espessura = 4;
        for (let j = 0; j < lista.length; j++) {
            if (rows[i][campo[0]] === lista[j]) { 
                espessura = 1;
                break; 
            }
        }
        if (rows[i][campo[0]] < 198) {
            desenhaCirc(rows[i], cor, espessura, map);
        } else {
            let ref = rows[i][campo[0]] - 198;
            desenhaQuad(zonasLat[ref], zonasLong[ref], cor, espessura, map);
        }
    }
    let desde = " De 9,999,999 a ";
    let ate = l1.toLocaleString('en-US') + " viagens";
    document.getElementById("verdescuro").innerHTML = desde + ate;
    desde = " De " + l1.toLocaleString('en-US') + " a ";
    ate = l2.toLocaleString('en-US') + " viagens";
    document.getElementById("verdeclaro").innerHTML = desde + ate;
    desde = " De " + l2.toLocaleString('en-US') + " a ";
    ate = l3.toLocaleString('en-US') + " viagens";
    document.getElementById("amarelo").innerHTML = desde + ate;
    desde = " De " + l3.toLocaleString('en-US') + " a ";
    ate = l4.toLocaleString('en-US') + " viagens";
    document.getElementById("laranja").innerHTML = desde + ate;
    desde = " De " + l4.toLocaleString('en-US') + " a ";
    ate = "0 viagens";
    document.getElementById("vermelho").innerHTML = desde + ate;
}

function odvAlertaDados(ling) {
    if (ling === 'pt') {
        alert ('Não há dados para o período especificado! Só de Jan 2018 a Fev 2021, inc. (excepto Abr 2020)');
    } else {
        alert ('No data for the specified period! Only for Jan 2018 to Feb 2021, inc. (Apr 2020 excluded)')
    }
}